import React, { useState } from "react";
import { Modal } from "react-responsive-modal";
import { useFormik } from "formik";
import * as Yup from "yup";
import CustomTextArea from "components/CustomTextArea";
import Loader from "components/Loader";
import Button from "components/CustomButton";
import { ReactComponent as CloseIcon } from "assets/img/icons/cancel.svg";
import { ReactComponent as CicleIcon } from "assets/img/icons/circle-dot-svgrepo-com.svg";
import { ReactComponent as DotCircleIcon } from "assets/img/icons/dot-circle-svgrepo-com.svg";

var styles = {
  titleDailog: {
    padding: "24px 24px 20px",
    position: "relative",
    fontSize: "1.25rem",
    fontWeight: "900",
    display: "flex",
    justifyContent: "center",
    marginBottom: "0",
  },
  headingDailog: {
    fontSize: "1rem",
    marginBottom: "12px",
  },
  content: {
    display: "flex",
    gap: "5px",
    alignItems: "center",
    padding: "8px 0",
  },
  mainContent: {
    border: "1px solid #0000004a",
    borderRadius: "10px",
    padding: "10px",
  },
  actionButton: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    padding: "10px 8px",
  },
  buttonStyle: {
    padding: "10px 65px",
    fontSize: "18px",
  },
  textAreaContent: {
    paddingTop: "10px",
    paddingBottom: "10px",
  },
  closeIcon: {
    width: "20px",
    position: "absolute",
    right: 0,
    top: "20px",
  },
};

export default ({
  rejectModalOpen,
  setRejectModalOpen,
  rejectInvitation,
  rejectInviteCode,
}) => {
  const classes = styles;
  const [loading, setLoading] = useState(false);
  const allRejectReason = [
    {
      id: 1,
      select: false,
      description: "I think this was send to wrong person.",
    },
    {
      id: 2,
      select: false,
      description:
        "Not interesting in at this time. May reconsider at later date.",
    },
    {
      id: 3,
      select: false,
      description:
        "I have too much on my plate and will not be able to contribute.",
    },
    {
      id: 4,
      select: false,
      description: "Other",
    },
  ];

  const formik = useFormik({
    initialValues: {
      Reason: allRejectReason[0].description,
      selectedReason: { id: 1 },
    },
    validationSchema: Yup.object().shape({
      Reason: Yup.string()
        .min(5, "Reason must be between 5 to 250 characters")
        .max(250, "Reason must be between 5 to 250 characters")
        .required("Reason is required"),
    }),
    onSubmit: async (values) => {
      try {
        setLoading(true);
        await rejectInvitation(values.Reason, rejectInviteCode);
        setRejectModalOpen(false);
      } catch (e) {
        console.log(e);
      }
    },
  });

  const handleClick = (reason) => {
    if (reason.id === 4) {
      formik.setFieldValue("selectedReason", reason);
      formik.setFieldValue("Reason", "");
      return;
    }

    if (formik.values.selectedReason.id !== reason.id) {
      formik.setFieldValue("selectedReason", reason);
      formik.setFieldValue("Reason", reason.description);
    }
    return;
  };

  return (
    <Modal
      open={rejectModalOpen}
      onClose={() => setRejectModalOpen(false)}
      showCloseIcon={false}
      classNames={{ modalContainer: "modalContainer", modal: "modalPadding" }}
    >
      <form noValidate onSubmit={formik.handleSubmit}>
        <div className="modal-body">
          <h2 style={classes.titleDailog}>
            Confirm to Reject
            <div style={classes.closeIcon}>
              <CloseIcon onClick={() => setRejectModalOpen(false)} />
            </div>
          </h2>
          <div className="rejectModalContent">
            <h6 style={classes.headingDailog}>
              <div style={classes.mainContent}>
                {allRejectReason.map((reason) => (
                  <div
                    key={reason.id}
                    style={classes.content}
                    onClick={() => handleClick(reason)}
                  >
                    <div>
                      {formik.values.selectedReason.id !== reason.id && (
                        <CicleIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                      {formik.values.selectedReason.id === reason.id && (
                        <DotCircleIcon
                          style={{
                            width: "20px",
                            height: "20px",
                            cursor: "pointer",
                          }}
                        />
                      )}
                    </div>
                    <div style={{ fontWeight: "600" }}>
                      {reason.description}
                    </div>
                  </div>
                ))}
                {formik.values.selectedReason.id === 4 && (
                  <div style={classes.textAreaContent}>
                    <CustomTextArea
                      errorClass="textStyle"
                      textAreaClass="form-control"
                      fieldName={"Reason"}
                      formik={formik}
                      placeholder="Write Reason"
                      limit={250}
                      rows={3}
                    />
                  </div>
                )}
              </div>
            </h6>
          </div>
          <div style={classes.actionButton}>
            <Button
              buttonClass="small-reject-btn "
              buttonStyle={classes.buttonStyle}
              name={!loading ? "reject" : <Loader width={30} height={30} />}
              disabled={loading && true}
            />
          </div>
        </div>
      </form>
    </Modal>
  );
};
